export default "/assets/images/problem-solved-08.78b93e5f005393c6.webp";